import { AspectRatioPicture } from "@faire/deprecated-retailer-visitor-shared/components/Image/AspectRatioPicture";
import { Image } from "@faire/deprecated-retailer-visitor-shared/components/Image/Image";
import { LazySamplesRequestModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/SamplesRequestModal/LazySamplesRequestModal";
import { SamplesRequestStoreProvider } from "@faire/deprecated-retailer-visitor-shared/components/Modals/SamplesRequestModal/SamplesRequestStore";
import { SamplesRequestModalSource } from "@faire/deprecated-retailer-visitor-shared/components/Modals/SamplesRequestModal/types";
import { Core } from "@faire/design-tokens";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ISimpleBrandTile } from "@faire/web-api--source/indigofair/data/ISimpleBrandTile";
import brandPage from "@faire/web-api--source/routes/www/brand/brandToken";
import { optimizeProductImageUrl } from "@faire/web/common/images/optimizeImages";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { Link } from "@faire/web/ui/LinkAnchor";
import React, { Suspense } from "react";
import styled from "styled-components";

interface IProps {
  simpleBrandTile: ISimpleBrandTile;
  sourcePage: SamplesRequestModalSource | undefined;
  onClick?: (token: string) => void;
}

const IMAGE_WIDTH = 220;

export const SampleBrandTile: React.FunctionComponent<IProps> = ({
  simpleBrandTile,
  sourcePage,
  onClick,
}) => {
  const [showSamplesModal, setShowSamplesModal] = React.useState(false);
  const isSSR = useIsSSR();

  return (
    <StyledColumn>
      <StyledLink
        onClick={() => {
          onClick?.(simpleBrandTile.token ?? "");
        }}
        data-test-id="sample-brand-tile"
        to={brandPage(simpleBrandTile.token ?? "")}
      >
        <AspectRatioPicture $ratio={1} $width="100%">
          <Image
            src={optimizeProductImageUrl(
              simpleBrandTile.profile_image_proto ?? IImage.build({}),
              isSSR,
              IMAGE_WIDTH
            )}
          />
        </AspectRatioPicture>
        <BrandNameWrapper>
          <Typography truncate variant="paragraphSansMedium">
            {simpleBrandTile.name}
          </Typography>
        </BrandNameWrapper>
      </StyledLink>
      <StyledButton
        variant="secondary"
        onClick={() => setShowSamplesModal(true)}
      >
        {simpleBrandTile.cta_text}
      </StyledButton>
      {showSamplesModal && simpleBrandTile.token ? (
        <Suspense fallback={null}>
          <SamplesRequestStoreProvider>
            <LazySamplesRequestModal
              brandToken={simpleBrandTile.token}
              source={sourcePage ?? "HOME"}
              onClose={() => setShowSamplesModal(false)}
            />
          </SamplesRequestStoreProvider>
        </Suspense>
      ) : null}
    </StyledColumn>
  );
};

const BrandNameWrapper = styled.div`
  text-align: center;
  padding: ${getSpacing("2x")};
  width: 100%;
`;

const StyledColumn = styled(Column).attrs({
  justify: "space-between",
  align: "center",
})`
  background: ${Core.surface.inverse};
`;

const StyledButton = styled(Button)`
  width: 80%;
  margin-bottom: ${getSpacing("2x")};
`;

const StyledLink = styled(Link)`
  display: contents;
`;
